module.exports = __webpack_public_path__ + "img/ic_clear_24px_white.03b3442d.svg";